import React from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { PATHS } from "@/lib/router";
// import RoutePaths from '@/utilities/constants/route-paths';
import { useTran } from "@/hooks";
import { Can } from "@/hooks/useCan/Can";
import { useAuthStore } from "@/features/auth";

const CarbonSMEContribution = ({ contributions = [], year }) => {
  const navigate = useNavigate();
  const isAllYears = year === "all";
  const { t } = useTran();
  const { user } = useAuthStore();

  const permissions = user?.permissions || [];

  const getReviewBadgeClass = (status) => {
    if (status === "approved") return "bg-emerald-600 text-white";
    if (status === "rejected") return "bg-rose-600 text-white";
    return "bg-amber-500 text-white";
  };

  return (
    <Card className="border-slate-200 dark:border-slate-800">
      <CardHeader>
        <CardTitle className="text-base">{t("SME Contributions")}</CardTitle>
        <p className="text-sm text-slate-500 dark:text-slate-400">
          {t("Individual SME submissions and their approval status")}
        </p>
      </CardHeader>
      <CardContent>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="border-b border-slate-200 bg-slate-50 text-xs text-slate-600 dark:border-slate-700 dark:bg-slate-900/40 dark:text-slate-300">
              <tr>
                <th className="px-4 py-3 text-left font-medium">SME</th>
                {isAllYears && (
                  <th className="px-4 py-3 text-center font-medium">
                    {t("Year")}
                  </th>
                )}
                <th className="px-4 py-3 text-right font-medium">
                  {t("Scope 1 (tCO₂e)")}
                </th>
                <th className="px-4 py-3 text-right font-medium">
                  {t("Scope 2 (tCO₂e)")}
                </th>
                <th className="px-4 py-3 text-center font-medium">
                  {t("Bank Review")}
                </th>
                <th className="px-4 py-3"></th>
              </tr>
            </thead>
            <tbody>
              {contributions.map((sme, index) => (
                <tr
                  key={`${sme.smeId}-${sme.year || index}`}
                  className="border-b border-slate-200 transition-colors hover:bg-slate-50 dark:border-slate-800 dark:hover:bg-slate-900/20"
                >
                  <td className="px-4 py-3 font-medium text-slate-900 dark:text-white">
                    {sme.smeName}
                  </td>
                  {isAllYears && (
                    <td className="px-4 py-3 text-center text-slate-700 dark:text-slate-200">
                      {sme.year || "N/A"}
                    </td>
                  )}
                  <td className="px-4 py-3 text-right text-slate-700 dark:text-slate-200">
                    {sme.scope1.toFixed(2)}
                  </td>
                  <td className="px-4 py-3 text-right text-slate-700 dark:text-slate-200">
                    {sme.scope2.toFixed(2)}
                  </td>
                  <td className="px-4 py-3 text-center">
                    <Badge className={getReviewBadgeClass(sme.reviewStatus)}>
                      {sme.reviewStatus}
                    </Badge>
                  </td>
                  <td className="px-4 py-3 text-right">
                    <Can
                      resource="carbon_submissions"
                      action="view"
                      userPermissions={permissions}
                    >
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={() =>
                          navigate(
                            PATHS.CARBON_SUBMISSIONS_EDIT.replace(
                              ":id",
                              sme._id,
                            ),
                          )
                        }
                      >
                        {t("View")}
                      </Button>
                    </Can>
                  </td>
                </tr>
              ))}
              {contributions.length === 0 && (
                <tr>
                  <td
                    className="px-4 py-8 text-center text-slate-500"
                    colSpan={isAllYears ? 6 : 5}
                  >
                    {t("No SME submissions found.")}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </CardContent>
    </Card>
  );
};

export default CarbonSMEContribution;
